<template>
  <div class="confettiContainerCanvas"> 
    <!-- <div ref="confettiContainer"></div> -->
    </div>
</template>  
<script>
import confetti from 'canvas-confetti';
export default {
  name: 'ConfettiExplosion',   
  components: {
  },
  props:{
   
  },
  data() {
    return {
    //  isExploding:false
     animationFrameId:null,
      endTime:null,
      isRunning: false,
      colors: ["#0f2647", "#9e7cfd","#9631f2","#c42b31","#e28128"], // 纸屑颜色（红白相间）
      intervalId: null, // 新增：用于存储 setInterval 的 ID
    }
  },
  mounted() {
  },
  beforeDestroy() {
  
  },
  beforeDestroy() {
    // 组件销毁时清理动画
    this.stopConfetti();
  },
  methods: {
  
    triggerConfetti() {
      if (this.isRunning) return;

      var duration = 0.75 * 1000;
      var animationEnd = Date.now() + duration;
      var defaults = { 
        startVelocity: 30, 
        spread: 360, 
        ticks: 150, 
        colors: this.colors
      };

      function randomInRange(min, max) {
        return Math.random() * (max - min) + min;
      }

      this.intervalId = setInterval(() => {
        var timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          this.stopConfetti();
          return;
        }

        var particleCount = 150 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 } });
        confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 } });
      }, 250);

      this.isRunning = true;
    },
    stopConfetti() {
      this.isRunning = false;
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
        this.animationFrameId = null;
      }
    },
    runFrame() {
      // 这个方法现在可以删除，因为使用了 setInterval
      // 保留是为了兼容性，但实际不会被执行
    },
    
  }
}
</script>
<style lang="scss">
    // .cp-dwp--popup{
    //   display: none !important;
    // }
</style>